import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { AuthContext } from "./auth-context";
import { usePatchUser, useUser } from "../api/use-user";
import * as Sentry from "@sentry/browser";

const getDefaultValue = () => ({
  user: null,
});

export const UserContext = createContext({
  ...getDefaultValue(),
  reload: () => Promise.resolve(),
  setLanguage: () => Promise.resolve(),
});

export const UserProvider = ({ children }) => {
  const [state, setState] = useState(getDefaultValue());
  const { isInitialized, isAuthenticated } = useContext(AuthContext);
  const [{ data: getData }, executeGet] = useUser("me");
  const [{ data: setData }, executePatch] = usePatchUser("me");

  const reload = useCallback(() => {
    const actual = async () => {
      await executeGet();
    };
    actual().catch(console.log);
  }, [executeGet]);

  const setLanguage = useCallback(
    (language) => {
      const actual = async () => {
        await executePatch({
          data: {
            language: language,
          },
        });
      };
      actual().catch(console.log);
    },
    [executePatch]
  );

  useEffect(() => {
    if(getData)
      setState((x) => ({ ...x, user: getData }));
  }, [getData]);

  useEffect(() => {
    if(setData)
      setState((x) => ({ ...x, user: setData }));
  }, [setData]);

  useEffect(() => {
    if(state)
      Sentry.setUser({ id: state.id, email: state.email });
    else
      Sentry.setUser(null);
  }, [state]);

  useEffect(() => {
    if (isInitialized) {
      if (isAuthenticated) {
        reload();
      } else {
        setState(null);
      }
    }
  }, [isInitialized, isAuthenticated, reload]);

  return (
    <UserContext.Provider
      value={{
        ...state,
        reload,
        setLanguage,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
